import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { money } from "@/lib/brand";

const IMG = "/images/approved/woman-who-loved-me";
export const Hero = ({ price }) => <section className="hero" aria-labelledby="hero-title" data-testid="home-hero">
  <div className="hero-grid">
    <div className="hero-head k-fade-in">
      <h1 id="hero-title" className="display-xl" data-testid="hero-title"><span>Your story.</span> <em>Beautifully bound.</em></h1>
    </div>
    <figure className="hero-media" data-testid="hero-media">
      <img src={`${IMG}-960.webp`} srcSet={`${IMG}-640.webp 640w, ${IMG}-960.webp 960w, ${IMG}-full.webp 1086w`} sizes="(max-width: 899px) 100vw, 50vw" width="1086" height="1448" fetchPriority="high" alt="A Keepsake softcover titled The Woman Who Loved Me Before I Was Cool, on a balcony table beside a cup of coffee at sunset" data-testid="hero-image"/>
      <figcaption className="hero-caption" data-testid="hero-caption"><i>The Woman Who Loved Me Before I Was Cool</i><span>A Keepsake Storybook</span></figcaption>
    </figure>
    <div className="hero-body k-fade-in" style={{ animationDelay: ".12s" }}>
      <p className="lede" data-testid="hero-description">Turn your favourite memories, photos and little moments into a personalised book made for someone who matters.</p>
      <div className="hero-actions">
        <Link to="/create/new" className="btn-primary" data-testid="hero-create-cta">Create Your Keepsake <ArrowRight size={16}/></Link>
        <a href="#the-book" className="text-link" data-testid="hero-explore-cta">See Inside the Book</a>
      </div>
      <p className="hero-meta" data-testid="hero-starting-price">Softcover storybook{price ? `, ${money(price)}` : ""}</p>
    </div>
  </div>
</section>;
